import graphql__cb620a8698f4478b9d2c from "./__generated__/TransferAppSectionQuery.graphql.ts";import { Heading } from '@portal/components'
import { graphql } from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { useAppManagementContext } from 'scenes/appManagement/context'

import { TransferAppSectionQuery } from './__generated__/TransferAppSectionQuery.graphql'
import TransferAppDestination from './TransferAppDestination'
import TransferAppDestinationSelector from './TransferAppDestinationSelector'

export const query = graphql__cb620a8698f4478b9d2c

const TransferAppSection = () => {
  const { appId } = useAppManagementContext()
  const { databaseText } = useAppToDatabaseRename()
  const { viewer } = useLazyLoadQuery<TransferAppSectionQuery>(
    query,
    { appId },
    {
      fetchPolicy: 'store-and-network',
    },
  )

  const renderTransferContent = () => {
    if (viewer.appById?.transferRequestDestination) {
      return (
        <TransferAppDestination
          destination={viewer.appById.transferRequestDestination}
          canCancel={viewer.appById.viewerCanTransfer}
          appId={appId}
        />
      )
    }

    if (viewer.appById?.viewerCanTransfer) {
      return <TransferAppDestinationSelector appId={appId} />
    }

    const organizationOwner = viewer.appById?.tenant?.owner?.user
    const ownerName =
      organizationOwner?.firstName || organizationOwner?.lastName
        ? `${organizationOwner.firstName} ${organizationOwner.lastName}`.trim()
        : organizationOwner?.email

    return (
      <p>
        {`Use this section to transfer the ${databaseText} to a different user or
          organization. Only the organization owner, ${ownerName}, is
          allowed to transfer this ${databaseText}.`}
      </p>
    )
  }

  return (
    <div>
      <Heading level={3}>Transfer {databaseText}</Heading>
      <p className="text-base text-foreground-subtle">
        Transfer your {databaseText} to another person or organization
      </p>
      {renderTransferContent()}
    </div>
  )
}

export default TransferAppSection
